import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=28795bcb&"
import script from "./ImageModal.vue?vue&type=script&lang=js&"
export * from "./ImageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28795bcb')) {
      api.createRecord('28795bcb', component.options)
    } else {
      api.reload('28795bcb', component.options)
    }
    module.hot.accept("./ImageModal.vue?vue&type=template&id=28795bcb&", function () {
      api.rerender('28795bcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/ImageModal.vue"
export default component.exports